import React from "react";
import PageHeader from "../../Components/layout/PageHeader";

const Privacypolicy = () => {
  return (
    <div className="bg-black h-screen overflow-hidden overflow-y-scroll">
      <PageHeader />
      <div className="text-white m-3 ">
        <b>Privacy policy</b>
        <div className="mt-2 text-sm">
          <h6 class="text-sm">
            We are committed to protecting your privacy. This Privacy Policy
            describes how we collect, use, and disclose your personal
            information when you use our application.
          </h6>
          <p>
            We do not collect any personal information from our users. We may
            collect non-personal information such as device information and
            usage data to improve our service and troubleshoot technical issues.
          </p>
          <h6 class="text-sm">Use of Information:</h6>
          <p>
            Any information we collect is used solely for the purpose of
            providing and improving our service. We do not sell or share your
            personal information with third parties.
          </p>
          <h6 class="text-sm">Notification Permissions:</h6>
          <p>
            Our application may request permission to send notifications for
            playing songs in the background. You can manage your notification
            preferences in your browser settings.
          </p>
          <h6 class="text-sm">Data Retention:</h6>
          <p>
            We do not store any personal data in our database. Any non-personal
            information collected is retained for as long as necessary to
            fulfill the purposes outlined in this Privacy Policy.
          </p>
          <h6 class="text-sm">Third-Party Services:</h6>
          <p>
            Our application may integrate with third-party services such as
            Google Authorization for authentication purposes. Your use of these
            services is subject to their respective privacy policies.
          </p>
          <h6 class="text-sm">Security:</h6>
          <p>
            We take reasonable precautions to protect your information from
            unauthorized access, use, or disclosure. However, no method of
            transmission over the internet or electronic storage is 100% secure.
          </p>
          <h6 class="text-sm">Children's Privacy:</h6>
          <p>
            Our service is not directed to children under the age of 13. If you
            are a parent or guardian and believe that your child has provided us
            with personal information, please contact us so that we can delete
            the information.
          </p>
          <h6 class="text-sm">Updates to Privacy Policy:</h6>
          <p>
            We may update this Privacy Policy from time to time. We will notify
            you of any changes by posting the new Privacy Policy on our website
            or application.
          </p>
          <h6 class="text-sm">Contact Us:</h6>
          <p>
            If you have any questions or concerns about our Privacy Policy,
            please contact us at rajadeepak1989@gmail.com.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacypolicy;
